(() => {
  if (window.ycVideoEditInitialized) return;
  window.ycVideoEditInitialized = true;
  let revision = 0;
  const initializeGalleries = () => {
    document.querySelectorAll('.yc-video-edit__gallery').forEach(track => {
      if (track.dataset.ycGalleryReady) return;
      track.dataset.ycGalleryReady = 'true';
      const warmImages = () => {
        const width = track.clientWidth;
        if (!width) return;
        const active = Math.round(Math.abs(track.scrollLeft) / width);
        [...track.querySelectorAll('img')].slice(Math.max(0, active - 1), active + 2).forEach(img => {
          img.loading = 'eager';
        });
      };
      track.addEventListener('scroll', warmImages, { passive: true });
      if (window.ResizeObserver) new window.ResizeObserver(warmImages).observe(track);
      warmImages();
    });
  };
  const refresh = async (suppliedCart) => {
    const token = ++revision;
    const regions = [...document.querySelectorAll('[data-yc-video-edit]')];
    if (!regions.length) return;
    regions.forEach(region => { region.querySelector('[data-yc-checkout]').disabled = true; });
    try {
      let cart = suppliedCart;
      if (!cart || !Number.isInteger(cart.item_count)) {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { headers: { Accept: 'application/json' }, cache: 'no-store' });
        if (!response.ok) throw new Error('cart_unavailable');
        cart = await response.json();
      }
      if (token !== revision) return;
      regions.forEach(region => {
        region.querySelector('[data-yc-count]').textContent = cart.item_count;
        region.querySelector('[data-yc-total]').textContent = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: cart.currency || region.dataset.currency }).format(cart.total_price / 100);
        region.querySelector('[data-yc-checkout]').disabled = cart.item_count < 1;
        region.querySelector('[data-yc-cart-status]').textContent = `${cart.item_count} · ${region.querySelector('[data-yc-total]').textContent}`;
      });
    } catch (_) {
      if (token === revision) regions.forEach(region => { region.querySelector('[data-yc-checkout]').disabled = true; });
    }
  };
  document.addEventListener('cart:updated', event => refresh(event.detail?.cart));
  document.addEventListener('shopify:section:load', () => { initializeGalleries(); refresh(); });
  window.addEventListener('pageshow', () => refresh());
  window.addEventListener('focus', () => refresh());
  initializeGalleries();
  refresh();
})();
